module.exports = __webpack_public_path__ + "img/IMG_8054 edit.211c35d3.webp";